import { useEffect, useRef } from "react";

export default function VantaBackground() {
  const vantaRef = useRef(null);
  const effectRef = useRef(null);

  useEffect(() => {

    let interval;

    const startVanta = () => {
      if (window.VANTA && window.THREE && vantaRef.current) {

        // destroy old instance if exists
        if (effectRef.current) {
          effectRef.current.destroy();
        }

        effectRef.current = window.VANTA.BIRDS({
          el: vantaRef.current,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          backgroundColor: 0x0a0f1c,
          color1: 0x00ffff,
          color2: 0xff00ff,
          birdSize: 1.2,
          wingSpan: 25,
          speedLimit: 4,
          quantity: 3
        });

        clearInterval(interval);
      }
    };

    // 🔥 keep checking until scripts ready
    interval = setInterval(startVanta, 0);

    return () => {
      clearInterval(interval);
      if (effectRef.current) {
        effectRef.current.destroy();
      }
    };

  }, []);

  return <div ref={vantaRef} className="fixed inset-0 -z-10"></div>;
}